<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>流量分类</span>
        <el-button type="primary" size="small" @click="openDialog()">新增分类</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="名称" min-width="140" />
        <el-table-column prop="sortOrder" label="排序" width="80" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ labelOf(COMMON_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑分类' : '新增分类'" :visible.sync="visible" width="420px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTrafficCategories, saveTrafficCategory, deleteTrafficCategory } from '@/api/admin'
import { COMMON_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'

export default {
  name: 'TrafficCategories',
  data() {
    return {
      COMMON_STATUS,
      loading: false,
      list: [],
      visible: false,
      submitting: false,
      form: { id: null, name: '', sortOrder: 0, status: 1 },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    async loadList() {
      this.loading = true
      try {
        this.list = await getTrafficCategories() || []
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openDialog(row) {
      this.form = row ? { ...row } : { id: null, name: '', sortOrder: 0, status: 1 }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await saveTrafficCategory(this.form)
          this.$message.success('保存成功')
          this.visible = false
          this.loadList()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该分类？', '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteTrafficCategory(row.id)
          this.$message.success('已删除')
          this.loadList()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.danger {
  color: #f56c6c;
}
</style>
